import { render, staticRenderFns } from "./Gifts.vue?vue&type=template&id=2857e594&scoped=true&"
import script from "./Gifts.vue?vue&type=script&lang=js&"
export * from "./Gifts.vue?vue&type=script&lang=js&"
import style0 from "./Gifts.vue?vue&type=style&index=0&id=2857e594&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2857e594",
  null
  
)

export default component.exports